module.exports = __webpack_public_path__ + "static/media/02.e4008d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/02.jpg
// module id = 692
// module chunks = 0